import store from '../store'
import { has } from '../utilities'

export const role = Object.freeze({
    master_admin: 1,
    school_owner: 2,
    school_admin: 3,
    athletics_admin: 4,
    academic_advisor: 5,
    coach: 6,
    professor: 7,
    ta: 8,
    class_checker: 9
})
export const allRoles = Object.values(role)
export const allAdmins = [ role.master_admin, role.school_owner, role.school_admin, role.athletics_admin ]

const getId = () => store.getters.role
export const isMasterAdmin = () => getId() <= role.master_admin
export const isAdmin = () => getId() <= role.athletics_admin
export const isAdvisor = () => getId() == role.academic_advisor
export const isCoach = () => getId() == role.coach
export const isProfessor = () => getId() == role.professor

export const hasRole = function(roles) {
    if (!Array.isArray(roles)) return false
    return roles.indexOf(store.getters.role) >= 0
}

export const routeAllowed = function(to) {
    if (has(to, 'meta.roles')) {
        if (!hasRole(to.meta.roles)) {
            return false
        }
    }
    return true
}

export const plugin = {
    install: function (Vue) {
        Vue.prototype.$role = {
            is: hasRole,
            isMasterAdmin,
            isAdmin,
            isAdvisor,
            isCoach,
            isProfessor,
            ...role
        }
    }
}
